import { render } from "./IndividualInfoScience.vue?vue&type=template&id=45b39eb6&scoped=true"
import script from "./IndividualInfoScience.vue?vue&type=script&lang=js"
export * from "./IndividualInfoScience.vue?vue&type=script&lang=js"

import "./IndividualInfoScience.vue?vue&type=style&index=0&id=45b39eb6&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b39eb6"]])

export default __exports__